import { render, staticRenderFns } from "./CustomerDocumentList.vue?vue&type=template&id=5530fab6&"
import script from "./CustomerDocumentList.vue?vue&type=script&lang=js&"
export * from "./CustomerDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports